import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-959e870d.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import '../Box/Box.js';
import 'react';
import 'reakit-utils/useForkRef';
import 'reakit-utils/isButton';
import 'reakit-warning';
import 'reakit-utils/useLiveRef';
import 'reakit-utils/tabbable';
import 'reakit-utils/hasFocusWithin';
import '../Tabbable/Tabbable.js';
import '../Clickable/Clickable.js';
import '../Button/Button.js';
import 'reakit-utils/useSealedState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import 'reakit-utils/useIsomorphicEffect';
import '../Disclosure/DisclosureState.js';
import { useDialogState } from './DialogState.js';
import { useDisclosure } from '../Disclosure/Disclosure.js';

var useDialogDisclosure = createHook({
  name: "DialogDisclosure",
  compose: useDisclosure,
  useState: useDialogState,
  useProps: function useProps(_, htmlProps) {
    return _objectSpread2({
      "aria-haspopup": "dialog"
    }, htmlProps);
  }
});
var DialogDisclosure = createComponent({
  as: "button",
  memo: true,
  useHook: useDialogDisclosure
});

export { DialogDisclosure, useDialogDisclosure };
